"use client"

import { Separator, Text } from "@chakra-ui/react"
import { HStack, VStack } from "@chakra-ui/react/stack"

import AccordionExperience from "@/components/AccordionExperience/AccordionExperience"

const TimelineWorkExperience: React.FC<{ data: any }> = ({ data }) => {
  return (
    <VStack
      alignItems="stretch"
      as="section"
      flexWrap="nowrap"
      gap={0}
      justifyContent="flex-start"
      mb={6}
      overflow="visible"
      position="relative"
      zIndex={1}
    >
      <HStack
        alignItems={"center"}
        bgColor={"transparent"}
        className="preface"
        flexDirection="row"
        justifyContent={"flex-start"}
        py={{
          base: 4,
          md: 6,
          lg: 8,
        }}
        w={"100%"}
        zIndex={3}
      >
        <HStack flexGrow={1} flexShrink={0} width={"50%"}>
          <Text
            _dark={{ color: "primary.200" }}
            _empty={{ display: "none" }}
            as={"p"}
            className="preface"
            color="primary.500"
            display="inline"
            fontFamily={"code"}
            fontSize={{ base: "xs", md: "md" }}
          >
            Work Experience
          </Text>
          <Separator
            as="hr"
            borderColor="border.emphasized"
            flexGrow="1"
            marginLeft="12px"
            marginRight="12px"
            variant="solid"
            width="auto"
            zIndex="-1"
          />
        </HStack>
        <HStack
          display={{ lg: "flex", lgDown: "none" }}
          flexGrow={1}
          flexShrink={0}
          width={"50%"}
        >
          <Separator
            as="hr"
            borderColor="border.emphasized"
            flexGrow="1"
            marginLeft="12px"
            marginRight="12px"
            variant="solid"
            width="auto"
            zIndex="-1"
          />
          <Text
            _dark={{ color: "primary.200" }}
            _empty={{ display: "none" }}
            as={"p"}
            className="preface"
            color="primary.500"
            fontFamily={"code"}
            fontSize={{ base: "xs", md: "md" }}
          >
            Education
          </Text>
        </HStack>
      </HStack>
      <AccordionExperience className="WorkExperience" data={data} />
    </VStack>
  )
}

export default TimelineWorkExperience
